import React from "react"
import Slider from "react-slick"
import "./Slider.scss"
import arrow from "../assets/icons/forward.png"
import {Link} from "react-router-dom"

function BannerSlider(props) {
   // console.log('inside BannerSlider Component', props)
    const {settings, data, title} = props
    const slideritems = data.map((item, i) => (
        <Link to={`/game/${item.id}`} key={i}>
            <div className="card">
                <div className="card-image">
                    <figure className="image is-1by1">
                        <img src={item.gameImage} alt={item.title}/>
                    </figure>
                </div>
                <div className="card-content pl-2 pr-2 pt-1 pb-1">
                    <div className="content">
                        <h6 className="mb-0 title is-6">{item.gameName.length <= 12 ? item.gameName : item.gameName.slice(0, 12) + '...'}</h6>
                        <p>{item.gamePlayed}</p>
                    </div>
                </div>
            </div>
        </Link>
    ))
    return (
        <div className="columns is-multiline is-mobile common is-gapless">
            <div className="column is-full v-center rt">
                <h6 className="title is-6 has-text-white mb-0 line">{title}</h6>
                <Link className="button is-rounded is-small is-theme mr-auto" to="/games">
                    عرض الكل
                    <img src={arrow} alt="arrow" className="ml-1"/>
                </Link>
            </div>
            <div className="column is-full">
                <Slider {...settings}>
                    {slideritems}
                </Slider>
            </div>
        </div>
    )
}

export default BannerSlider